import { Component } from "@angular/core";
import { PolicyHeaderComponent } from "../policy-header/policy-header.component";

@Component({
  selector: "app-cp-00-10-10-12",
  standalone: true,
  imports: [PolicyHeaderComponent],
  templateUrl: "./cp-00-10-10-12.component.html",
  styleUrl: "./cp-00-10-10-12.component.scss",
})
export class Cp00101012Component {}
